export const Warning = (props) => {
  const { size = 20, onClick, verticalAlign, marginLeft, marginRight, top, color, className = ' ' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 20 20'>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M10 7.5v3.334m0 3.333h.008M8.846 3.243l-6.854 11.84c-.38.656-.57.984-.542 1.254a.833.833 0 00.339.587c.219.16.598.16 1.357.16h13.708c.759 0 1.138 0 1.358-.16a.834.834 0 00.338-.587c.028-.27-.162-.598-.542-1.255L11.154 3.243c-.379-.654-.568-.981-.815-1.091a.833.833 0 00-.677 0c-.248.11-.437.437-.816 1.091z'
        ></path>
      </svg>
    </span>
  );
};
